module.exports = __webpack_public_path__ + "static/img/why-micro-1.d24ae794.svg";